export const navigation = [
  // {
  //   text: 'Home',
  //   path: '/home',
  //   icon: 'home'
  // },
  // {
  //   text: 'Examples',
  //   icon: 'folder',
  //   items: [
  //     {
  //       text: 'Profile',
  //       path: '/profile'
  //     },
  //     {
  //       text: 'Tasks',
  //       path: '/tasks'
  //     }
  //   ]s
  // },

  {
    text: "App Configuration",
    path: "/app-configuration",
    icon: "preferences",
  },
  {
    text: "Parameters",
    path: "/parameters",
    icon: "aligncenter",
  },

  {
    text: "Login & Security Settings",
    path: "/login-security",
    icon: "preferences",
  },

  {
    text: "Languages",
    path: "/languages",
    icon: "startswith",
  },
];
